import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useState } from 'react';

const STEPS = [
  'Select Portfolios',
  'Preview Trades',
  'Verify & Batch',
  'Execute',
];

const FlowBreadcrumb = () => {
  const { sys } = useThemeTokens();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        mt: 1.5,
        mb: -0.5,
        px: 1.5,
        py: 0.5,
        borderRadius: '4px',
        bgcolor: sys.color.surface,
        border: '1px solid',
        borderColor: sys.color.outlineVariant,
      }}
    >
      <Typography
        variant='labelSmall'
        sx={{
          color: sys.color.onSurfaceVariant,
          mr: 0.5,
          fontWeight: 700,
          textTransform: 'uppercase',
        }}
      >
        Flow
      </Typography>
      {STEPS.map((label, idx) => (
        <Box key={label} sx={{ display: 'flex', alignItems: 'center' }}>
          {idx > 0 && (
            <Typography
              variant='labelSmall'
              sx={{ mx: 0.5, color: sys.color.onDisabled }}
            >
              →
            </Typography>
          )}
          <Typography
            variant='labelSmall'
            sx={{ color: sys.color.onSurfaceVariant }}
          >
            {label}
          </Typography>
        </Box>
      ))}
      <Box sx={{ flex: 1 }} />
      <IconButton
        onClick={() => setDismissed(true)}
        sx={{ p: 0.25 }}
        label='Dismiss flow'
      >
        <CloseIcon sx={{ fontSize: 14, color: sys.color.onDisabled }} />
      </IconButton>
    </Box>
  );
};

export default FlowBreadcrumb;
